
document.addEventListener('click', async (e)=>{
  const btn=e.target.closest('[data-add-to-cart]');
  if(!btn)return;
  e.preventDefault();
  const form=btn.closest('form');
  if(!form)return;
  const fd=new FormData(form);
  btn.disabled=true; btn.textContent='ADDING…';
  try{
    const res=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd});
    if(!res.ok) throw new Error();
    btn.textContent='ADDED ✓';
    setTimeout(()=>{btn.disabled=false;btn.textContent='ADD TO BAG'},900);
  }catch(err){btn.disabled=false;btn.textContent='TRY AGAIN'}
});
